// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8830":"70d52633","9974":"2ddf8fc3"}[chunkId] + ".chunk.css";
};